export const POINT_OF_INTERESTS = [
  {
    id: 1,
    name: 'UAE',
  },
  {
    id: 2,
    name: 'Qatar',
  },
  {
    id: 3,
    name: 'Oman',
  },
  {
    id: 4,
    name: 'KSA',
  },
//   {
//     id: 4,
//     name: 'Saudi Arabia ',
//   }
];
